import React, { createContext, useState, useEffect } from "react";
import { encryptData, decryptData } from "../utils/encryption";
import { logoutResident } from "../services/resident_api";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [user_type, setUserType] = useState(null);
  const [authTokens, setAuthTokens] = useState(() => {
    const storedTokens = localStorage.getItem("authTokens");
    return storedTokens ? JSON.parse(storedTokens) : null;
  });

  // 🔐 On login, encrypt and store user data and userType
  const login = (tokens, userData, type) => {
    localStorage.removeItem("activeTab");

    setAuthTokens(tokens);
    localStorage.setItem("authTokens", JSON.stringify(tokens));

    const encrypted = encryptData(userData);
    localStorage.setItem("encryptedUser", encrypted);
    setUser(userData);

    localStorage.setItem("userType", type); // save user_type separately
    setUserType(type);
  };

  const updateUser = (newUserData) => {
    setUser((prev) => {
      const updatedUser = { ...prev, ...newUserData };

      // 🔐 re-encrypt and store
      const encrypted = encryptData(updatedUser);
      localStorage.setItem("encryptedUser", encrypted);

      return updatedUser;
    });
  };

  // 🚪 Logout cleanup
  const logout = async () => {
    const refresh = authTokens?.refresh;

    try {
      const logoutRespone = await logoutResident(refresh);
      console.log("Result:-", logoutRespone);
    } catch (err) {
      // Handle error silently or log if needed
    }

    setAuthTokens(null);
    setUser(null);
    setUserType(null);
    localStorage.removeItem("authTokens");
    localStorage.removeItem("encryptedUser");
    localStorage.removeItem("userType");
    localStorage.removeItem("currentDeliveryStep");
    localStorage.removeItem("deliverySession");
    localStorage.removeItem("returnToStep");
  };

  // 🔓 On mount, try to decrypt stored user and load userType
  useEffect(() => {
    const storedEncryptedUser = localStorage.getItem("encryptedUser");
    const storedUserType = localStorage.getItem("userType");

    if (storedEncryptedUser) {
      try {
        const decrypted = decryptData(storedEncryptedUser);
        setUser(decrypted);
      } catch (err) {
        setUser(null);
      }
    }

    // Handle old sessions: set default user_type if not present
    if (authTokens && !storedUserType) {
      setUserType("resident"); // Default for old resident users
      localStorage.setItem("userType", "resident"); // Persist default
      // Optionally fetch real user_type from server if needed
      // fetchUserType(authTokens.refresh).then((type) => {
      //   setUserType(type);
      //   localStorage.setItem("userType", type);
      // });
    } else if (storedUserType) {
      setUserType(storedUserType);
    }
  }, [authTokens]);

  return (
    <AuthContext.Provider
      value={{
        user,
        user_type,
        login,
        logout,
        updateUser, // ✅ ADD THIS
        isAuthenticated: !!authTokens,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
